<template>
  <div
    ref="button_animation"
    class="button button--progress"
    :class="extraClass"
    @mousedown="mouseDown"
    @mouseup="mouseUp"
    @touchstart="mouseDown"
    @touchend="mouseUp"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ProgressButtonMod",

  props: {
    extraClass: [String, Array, Object],
    duration: Number,
  },

  mounted() {
    this.$refs.button_animation.addEventListener("animationend", () => {
      this.$emit("progressEnd");
    });
  },

  methods: {
    mouseDown: function(e) {
      e.preventDefault();
      if (e.which !== 1 && e.type === "mousedown") return;
      let animation_duration = this.duration || 2;
      this.$refs.button_animation.classList.add("animation_inprogress");
      this.$refs.button_animation.style.animationDuration = `${animation_duration}s`;
    },
    mouseUp: function() {
      this.$refs.button_animation.classList.remove("animation_inprogress");
      this.$refs.button_animation.style.animationDuration = "";
    },
  },
};
</script>
